export default [
  {
    path: '',
    redirect: '/home',
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    component: () => import('@view/home')
  },
  {
    path: '/mall',
    component: () => import('@view/home')
  },
  {
    path: '/mall/home',
    component: () => import('@view/home')
  },
  {
    path: '/store/:action?',
    component: () => import('@view/store'),
    props: true
  },
  {
    path: '/order/:type?',
    component: () => import('@view/order'),
    children: [
      {
        path: '',
        component: () => import('@view/order/list')
      },
      {
        path: 'detail/:id',
        component: () => import('@view/order/detail')
      },
    ]
  },
  {
    path: '/auth',
    component: () => import('@view/auth')
  },
  {
    path: '/mainlandAuth',
    component: () => import('@view/mainlandAuth')
  },
  {
    path: '/voucher',
    component: () => import('@view/voucher')
  },
  {
    path: '/payment',
    component: () => import('@view/payment'),
  },
  {
    path: '/payment/success',
    component: () => import('@view/payment/success')
  },
  {
    path: '/payment/fail',
    component: () => import('@view/payment/fail')
  },
  // leads - io 售卖产品
  {
    path: '/leads-payment',
    component: () => import('@view/payment'),
  },
  {
    name:'AppointAccountTip',
    path: "/appoint-account-tip",
    component: () => import("@view/appointment/main-account-tip")
  },
  {
    name:'AppointSuccess',
    path: "/appoint-success",
    component: () => import("@view/appointment/success")
  },
  {
    name:'AppointCancel',
    path: "/appoint-cancel",
    component: () => import("@view/appointment/cancel")
  },
  {
    name:'AppointList',
    path: "/appointment-list",
    component: () => import("@view/appointment/appointment-list")
  },
  {
    name:'CrmExport',
    path: "/crm-export",
    component: () => import("@view/download/crm-export")
  },
  // 台湾注册页面
  {
    name: 'Register',
    path: '/register-tw',
    component: () => import('@view/register')
  },
  // 注册成功页面
  {
    name: 'RegisterSuccess',
    path: '/register-tw/success',
    component: () => import('@view/register/success')
  },
  // 日本注册页面
  {
    name: 'JpRegister',
    path: '/register',
    component: () => import('@view/jpRegister')
  },
  // 注册成功页面
  {
    name: 'JpRegisterSuccess',
    path: '/register/success',
    component: () => import('@view/jpRegister/success')
  },
  // 香港注册页面
  {
    name: 'HKRegister',
    path: '/register-hk',
    component: () => import('@view/register')
  },
  {
    name: 'HKRegisterSuccess',
    path: '/register-hk/success',
    component: () => import('@view/register/success')
  }
]
